import * as React from 'react';
import classNames from 'classnames';
import ReactModal, { Props as ModalProps } from 'react-modal';
import { observer } from 'mobx-react';
import { store } from 'Models/Store';

export interface IModalProps {
	/** Is the modal open */
	isOpen: boolean;
	/** A label for the modal for screen readers */
	label: string;
	/** The classname for the modal */
	className?: string;
	/** The classname for the modal overlay */
	overlayClassName?: string;
	/** Function that will be run after the modal has opened. */
	onAfterOpen?: () => void;
	/** Function that will be run after the modal has closed. */
	onAfterClose?: () => void;
	/**
	 * Function that will be run when the modal is requested to be closed, prior to actually closing.
	 * If the isOpen prop is not changed in this callback then it will not actually close!
	 */
	onRequestClose?: (event: React.MouseEvent | React.KeyboardEvent) => void;
	/**
	 * Raw props to be passed to react-modal.
	 * This will overwrite any props that are placed on the modal by this component
	 */
	modalProps?: ModalProps;
	/** Children elements */
	children: React.ReactNode;
	/** Boolean indicating if the overlay should close the modal. Defaults to true. */
	shouldCloseOnOverlayClick?: boolean;
	/** Boolean indicating if pressing the esc key should close the modal */
	shouldCloseOnEsc?: boolean;
	newModal?: boolean;
}
const rootId = 'root';
const modalElement = document.getElementById(rootId);

/**
 * A modal dialog that can display any content inside of it
 */
class Modal extends React.Component<IModalProps> {
	public render() {
		if (!modalElement) {
			console.error(`Could not find the #${rootId} element in the html. Could not create modal`);
			return <></>;
		}

		const {
			label,
			overlayClassName,
			onAfterOpen,
			onRequestClose,
			children,
			className,
			modalProps,
			isOpen,
			shouldCloseOnEsc = true,
			shouldCloseOnOverlayClick = true,
		} = this.props;

		return (
			<ReactModal
				className={classNames('modal-content', className)}
				overlayClassName={classNames('modal-container', overlayClassName)}
				portalClassName={classNames('portal', store.appLocation)}
				appElement={modalElement}
				isOpen={isOpen}
				onAfterOpen={onAfterOpen}
				onRequestClose={onRequestClose}
				contentLabel={label}
				shouldCloseOnEsc={shouldCloseOnEsc}
				shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
				aria={{
					// @ts-expect-error because the aria interface doesn't expose the aria-live property
					live: 'assertive',
				}}
				{...modalProps}
			>
				{children}
			</ReactModal>
		);
	}
}
export default observer(Modal);
